/*Version differences*/
let Vue = require('vue').default || require('vue');
let c = require('./config.json');

let apiUrls = ['https://wb-core.widgetbrain.io', 'https://wb-core-test.widgetbrain.io', 'https://wb-core-development.widgetbrain.io', 'http://localhost:3003'];
let remoteAPI = c.environment;

let utils = {
    token() {
        return localStorage.getItem('WBToken');
    },
    get(url, params) {
        let urlString = url;
        const token = this.token();
        params.push({ key: 'access_token', value: token });

        for (let i = 0; i < params.length; i++) {
            i === 0
                ? urlString += '?'
                : urlString += '&';

            urlString += `${params[i].key}=${params[i].value}`;
        }

        return new Promise((resolve, reject) => {
            Vue.http.get(urlString).then(
                res => {
                    resolve(res);
                },
                err => {
                    reject(err);
                }
            );
        });
    },
    post(url, params, data) {
        let urlString = url;
        const token = this.token();
        params.push({ key: 'access_token', value: token });

        for (let i = 0; i < params.length; i++) {
            i === 0
                ? urlString += '?'
                : urlString += '&';

            urlString += `${params[i].key}=${params[i].value}`;
        }
        return new Promise((resolve, reject) => {
            Vue.http.post(urlString, data).then(
                res => {
                    resolve(res);
                },
                err => {
                    reject(err);
                }
            );
        });
    },
    put(url, params, data) {
        let urlString = url;
        const token = this.token();
        params.push({ key: 'access_token', value: token });

        for (let i = 0; i < params.length; i++) {
            i === 0
                ? urlString += '?'
                : urlString += '&';

            urlString += `${params[i].key}=${params[i].value}`;
        }

        return new Promise((resolve, reject) => {
            Vue.http.put(urlString, data).then(
                res => {
                    resolve(res);
                },
                err => {
                    reject(err);
                }
            );
        });
    },
    delete(url, id, params) {

        let urlString = `${url}`;
        if (id) {
            urlString = `${url}/${id}`;
        }
        const token = this.token();
        urlString += '?access_token=' + token;
        if (params)
            for (let i = 0; i < params.length; i++) {
                urlString += '&';
                urlString += `${params[i].key}=${params[i].value}`;
            }
        return new Promise((resolve, reject) => {
            Vue.http.delete(urlString).then(
                res => {
                    resolve(res);
                },
                err => {
                    reject(err);
                }
            );
        });
    },

};


module.exports = {
    apiUrl: apiUrls[remoteAPI],
    /*User management*/
    getRole: function (remoteIndex, appId) {
        return utils.get(`${apiUrls[remoteIndex] || this.apiUrl}/api/WBUsers/getrole`, [{ key: 'appId', value: appId }]);
    },
    getUsersByApp: function (remoteIndex, appId) {
        return utils.get(`${apiUrls[remoteIndex] || this.apiUrl}/api/wbapps/getusers`, [{ key: 'appId', value: appId }])
    },
    addUser: function (remoteIndex, appId, user, role) {
        return utils.post(`${apiUrls[remoteIndex] || this.apiUrl}/api/WBusers/createfromapp`, [], { appId, user, role })
    },
    deleteUser: function (remoteIndex, userId) {
        return utils.post(`${apiUrls[remoteIndex] || this.apiUrl}/api/WBusers/removeUser`, [], { userId })
    },
    addRole: function (remoteIndex, appAssignment) {
        return utils.post(`${apiUrls[remoteIndex] || this.apiUrl}/api/UserAppAssignments`, [], appAssignment)
    },
    convertObject(obj) {
        let result = null;
        const objStr = JSON.stringify(obj);
        result = objStr.replace(/\{/g, '%7B');
        result = result.replace(/\}/g, '%7D');
        result = result.replace(/\:/g, '%3A');
        result = result.replace(/\"/g, '%22');
        result = result.replace(/\,/g, '%2C');
        result = result.replace(/ /g, '%20');
        return result;
    },
    getAllUserRoles: function (remoteIndex, userId) {
        return utils.get(`${apiUrls[remoteIndex] || this.apiUrl}/api/UserAppAssignments`, [
            { key: 'filter', value: this.convertObject({ where: { userId } }) }
        ])
    },
    getUsersByTeam: function (remoteIndex, appId, includeAllowed = false) {
        return utils.get(`${apiUrls[remoteIndex] || this.apiUrl}/api/WBusers/getList`, [
            { key: 'appId', value: appId, },
            { key: 'includeAllowed', value: includeAllowed }
        ])
    },
    addUserToTeam: function (remoteIndex, teamId, name, email, role, appId, hasConsoleAccess, hasProgrammaticAccess, activationLink) {
        return utils.post(`${apiUrls[remoteIndex] || this.apiUrl}/api/WBUsers/addToTeam`, [], { teamId, name, email, role, appId, hasConsoleAccess, hasProgrammaticAccess, activationLink });
    },
    checkUserEmail: function (remoteIndex, email) {
        return utils.post(`${apiUrls[remoteIndex] || this.apiUrl}/api/WBUsers/checkEmailIsAvailable`, [], { email });
    },
    addAdditionalRoles: function (remoteIndex, userId, role, appId) {
        let options = { role, userId, appId };
        return utils.post(`${apiUrls[remoteIndex] || this.apiUrl}/api/wbusers/role/assign`, [], options);
    },
    updateRole: function (remoteIndex, userId, role, appId) {
        let options = { role, userId, appId };
        return utils.post(`${apiUrls[remoteIndex] || this.apiUrl}/api/wbusers/role/assign`, [], options);
    },
    updateUser: function (remoteIndex, userId, name, description) {
        return utils.post(`${apiUrls[remoteIndex] || this.apiUrl}/api/WBusers/update`, [], {
          userId: userId,
          data: {
            name: name,
            metaData: {
              description: description,
            }
          }
        })
    },
};
